import { status as PS } from '../../../helpers/passport';
import { isAdmin } from '../../../services/rolesSvc';

const isProjectAdmin = ({ mine }, projId) => mine.projs && mine.projs.find((p) => p.projId === parseInt(projId) && (p.role === 'head' || p.role === 'admin'));
const isStratAdmin = ({ mine }, stratId) => mine.strategies && mine.strategies.find((p) => p.strategyId === parseInt(stratId) && (p.role === 'head' || p.role === 'admin'));

const rules = {
  Delete: {
    isStatusOk: (status) => [PS.draft, PS.returnedByPortf, PS.returnedByHeadSP, PS.returnedByExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isProjectAdmin(userCtx, projId) || isAdmin(userCtx),
  },
  Edit: {
    isStatusOk: (status) => [PS.draft, PS.onApproveHeadSP, PS.returnedByHeadSP, PS.returnedByExperts, PS.expertsDeclined, PS.approved, PS['-approved'], PS.onApproveExperts, PS.closed].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isProjectAdmin(userCtx, projId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
    extra: (status, userCtx, stratId) => ![PS.closed,PS.onApproveExperts,PS.onApproveHeadSP].includes(status)
        || (status === PS.onApproveExperts && isAdmin(userCtx, stratId)) // в статусе "На рассмотрении ЭГ" редактировать может только Проектный офис
      || (status === PS.onApproveHeadSP && isStratAdmin(userCtx, stratId)) // в статусе "На рассмотрении СП" редактировать может только СП
      || (status === PS.closed && isAdmin(userCtx)) // в статусе "Закрыт" редактирование только у ПО
  },
  EditCurrent: {
    isAnyVersion: true,
    isStatusOk: (status) => [PS.approved, PS['-approved'], PS.expertsApproved].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isAdmin(userCtx),
  },
  EditCurrentMilestones: {
    isStatusOk: (status) => [PS.approved, PS['-approved'], PS.expertsApproved].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isProjectAdmin(userCtx, projId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  SendToHead: {
    isStatusOk: (status) => [PS.draft, PS.returnedByHeadSP, PS.returnedByExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isProjectAdmin(userCtx, projId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  HeadSendToExperts: {
    isStatusOk: (status) => [PS.onApproveHeadSP].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  HeadReturn: {
    isStatusOk: (status) => [PS.onApproveHeadSP].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  ExpertsReturn: {
    isStatusOk: (status) => [PS.onApproveExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isAdmin(userCtx),
  },
  ExpertsApprove: {
    isStatusOk: (status) => [PS.onApproveExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isAdmin(userCtx),
  },
  ExpertsDecline: {
    isStatusOk: (status) => [PS.onApproveExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isAdmin(userCtx),
  },
  ApproveFinal: {
    isAnyVersion: true,
    isStatusOk: (status) => [PS.expertsApproved, PS.approved, PS['-approved'], PS.closed, PS.moved].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isProjectAdmin(userCtx, projId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  MoveProject: {
    isStatusOk: (status) => ![PS.closed, PS.moved].includes(status),
    isRoleOk: (userCtx) => isAdmin(userCtx)
  },
};

export const getActionsModel = (status, userCtx, stratId, projId, isLatestVersion) => Object.entries(rules).reduce((acc, [key, rule]) => ({
  ...acc,
  [key]: (isLatestVersion || rule.isAnyVersion)
    && rule.isStatusOk(status)
    && rule.isRoleOk(userCtx, stratId, projId)
    && (!rule.extra || rule.extra(status, userCtx, stratId)),
}), {});
